<figure>
  @if (dataSignal().img && dataSignal().img !== null) {
  <div class="flex">
    <img
      [src]="replaceBucket.replaceBucket(dataSignal().img)"
      [alt]="dataSignal().title"
      class="item-image"
      [title]="dataSignal().title"
      loading="lazy"
    />
  </div>
  } @else {
  <div class="item-image"></div>
  }
  <figcaption>
    <div class="promo-date">
      <h2 class="font-size-22 font-weight-bold text-title w-full">{{ dataSignal().title }}</h2>
      <div class="flex w-full text-left date">
        <p class="font-size-16 font-weight-semibold text-date">(ตั้งแต่วันที่&nbsp;</p>
        <p class="font-size-16 font-weight-semibold text-date">{{ dataSignal().publish_time }}</p>
        @if(dataSignal().unpublish_time){
        <p class="font-size-16 font-weight-semibold text-date">&nbsp;-&nbsp;</p>
        <p class="font-size-16 font-weight-semibold text-date">{{ dataSignal().unpublish_time }}</p>
        }
        <p class="font-size-16 font-weight-semibold text-date">)</p>
      </div>
    </div>
    <div class="font-size-16 font-weight-regular text-content" [innerHTML]="getSafeHtml(dataSignal().contentHTML || '')"></div>
    <!-- <div class="flex flex-col">
        <p class="text-seo-title">{{ dataSignal().seoPageTitle }}</p>
        @if(dataSignal().seoUrl){
        <a href="{{ dataSignal().seoUrl }}" class="font-color-black text-seo-title">{{ dataSignal().seoUrl }}</a>
        }
      </div>

      <p class="text-seo-description">{{ dataSignal().seoMetaDescription }}</p> -->
  </figcaption>
</figure>
